import { signal } from "@preact/signals-react"

export const isOpen = signal(false)
export const rowSelected = signal({})